app.factory('newUserRegistrationModel', ['$rootScope', 'baseModel', 'newUserRegistrationService',
    function ($rootScope, baseModel, newUserRegistrationService) {

        function NewUserRegistrationModel() {

            this.register = function (newUserWrapper) {
                newUserRegistrationService.register(newUserWrapper).then(
                    function (edmTokenWrapper) {
                        $rootScope.$broadcast(Event.NEW_USER_REGISTRATION.REGISTER.SUCCESS, edmTokenWrapper);
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.NEW_USER_REGISTRATION.REGISTER.ERROR, error);
                    }
                )
            };
        }

        return new NewUserRegistrationModel();
    }
]);
